export const removeAccents = (field:string) => {
    return field?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, "");
  } 
  

  export const removeAccentsExcpetn = (field:string) => {
  return field?.normalize('NFD')
           .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
           .normalize();
}
  